export class TouchDragManager {
  activeDrag: { clone: HTMLElement; source: HTMLElement } | null;
  offsetX: number;
  offsetY: number;
  overlapTargets: HTMLElement[];
  dropTargets: HTMLElement[];
  container: ShadowRoot;
  elements: { element: HTMLElement; touchFunction: (e: Event) => void }[] = [];

  constructor(container: ShadowRoot) {
    this.activeDrag = null;
    this.offsetX = 0;
    this.offsetY = 0;
    this.overlapTargets = [];
    this.dropTargets = [];
    this.container = container;
    this._bindEvents();
  }

  _bindEvents() {
    document.addEventListener("touchmove", this._onTouchMove.bind(this), {
      passive: false,
    });
    document.addEventListener("touchend", this._onTouchEnd.bind(this), {
      passive: false,
    });
  }

  disconnectEvent(element: HTMLElement) {
    const elementNodes = element.querySelectorAll("[draggable]");
    const elements = Array.from(elementNodes);

    if (element.hasAttribute("draggable")) elements.push(element);

    elements.forEach((el) => {
      let index = this.elements?.findIndex((e) => el == e.element);
      if (index < 0) return;
      const elementTouch = this.elements[index];
      this.elements = this.elements?.splice(index, 1);

      el.removeEventListener("touchstart", elementTouch.touchFunction);
    });
  }

  bindEvents(element: HTMLElement) {
    const elementNodes = element.querySelectorAll("[draggable]");
    const elements = Array.from(elementNodes);

    if (element.hasAttribute("draggable")) elements.push(element);
    elements.forEach((el) => {
      let index = this.elements?.findIndex((e) => el == e.element);
      if (index > 0) return;

      const elementTouch = {
        element: el as HTMLElement,
        touchFunction: (e: Event) => this._onTouchStart(e as TouchEvent, el),
      };
      this.elements.push(elementTouch);

      el.addEventListener("touchstart", elementTouch.touchFunction, {
        passive: false,
      });
    });
  }

  _onTouchStart(e: TouchEvent, originalEl: Element) {
    const touch = e.touches[0];
    const rect = originalEl.getBoundingClientRect();

    this.offsetX = touch.clientX - rect.left;
    this.offsetY = touch.clientY - rect.top;

    // Klon oluştur
    const clone = originalEl.cloneNode(true) as HTMLElement;
    Object.assign(clone.style, {
      position: "fixed",
      left: `${rect.left}px`,
      top: `${rect.top}px`,
      width: `${rect.width}px`,
      height: `${rect.height}px`,
      opacity: "0.5",
      pointerEvents: "none",
      zIndex: "9999",
      touchAction: "none",
    });
    clone.classList.add("drag-clone");
    document.body.appendChild(clone);

    this.activeDrag = {
      clone,
      source: originalEl as HTMLElement,
    };

    this.updateTargets();

    originalEl.dispatchEvent(
      new CustomEvent("dragstart", {
        detail: {
          clientX: e.touches[0].clientX,
          clientY: e.touches[0].clientY,
        },
      })
    );
  }

  updateTargets() {
    this.overlapTargets = Array.from(
      this.container.querySelectorAll("[mobiledragover]")
    ).map((el) => el as HTMLElement);

    // Drop hedeflerini güncelle
    this.dropTargets = Array.from(
      this.container.querySelectorAll("[mobiledrop]")
    ).map((el) => el as HTMLElement);

    //.filter((el) => typeof el.getAttribute("drop")?.startsWith("function"))
    //console.log("overlapTargets", this.overlapTargets);
    //console.log("dropTargets", this.dropTargets);
  }

  _onTouchMove(e: TouchEvent) {
    if (!this.activeDrag) return;

    e.preventDefault();
    const touch = e.touches[0];
    const clone = this.activeDrag.clone;
    const source = this.activeDrag.source;

    clone.style.left = `${touch.clientX - this.offsetX}px`;
    clone.style.top = `${touch.clientY - this.offsetY}px`;

    const dragRect = clone.getBoundingClientRect();

    for (const target of this.overlapTargets) {
      const targetRect = target.getBoundingClientRect();
      const intersect =
        dragRect.left < targetRect.right &&
        dragRect.right > targetRect.left &&
        dragRect.top < targetRect.bottom &&
        dragRect.bottom > targetRect.top;

      if (intersect) {
        target.dispatchEvent(
          new CustomEvent("dragover", {
            detail: {
              source: source,
              clientX: e.touches[0].clientX,
              clientY: e.touches[0].clientY,
            },
          })
        );
      }
    }
  }

  _onTouchEnd(e: TouchEvent) {
    if (!this.activeDrag) return;

    const clone = this.activeDrag.clone;
    const source = this.activeDrag.source;

    const dragRect = clone.getBoundingClientRect();

    for (const target of this.dropTargets) {
      const targetRect = target.getBoundingClientRect();
      const intersect =
        dragRect.left < targetRect.right &&
        dragRect.right > targetRect.left &&
        dragRect.top < targetRect.bottom &&
        dragRect.bottom > targetRect.top;

      if (intersect) {
        target.dispatchEvent(
          new CustomEvent("drop", {
            detail: {
              source: source,
            },
          })
        );
      }
    }

    clone.remove();
    this.activeDrag = null;
    this.overlapTargets = [];
    this.dropTargets = [];
  }

  clear() {}
}
